import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
const SvgSso = (props)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        "aria-hidden": "true",
        viewBox: "0 0 48 48",
        ...props,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fill: "#fff",
                stroke: "#000",
                strokeMiterlimit: 10,
                strokeWidth: 1.31,
                d: "M4.952 22.616c2.182 0 3.951-1.753 3.951-3.917s-1.77-3.917-3.951-3.917C2.769 14.782 1 16.536 1 18.7s1.77 3.917 3.952 3.917ZM43.049 22.616C45.23 22.616 47 20.863 47 18.7s-1.769-3.917-3.951-3.917-3.952 1.754-3.952 3.917 1.77 3.917 3.952 3.917ZM24.13 11.334c2.182 0 3.95-1.754 3.95-3.917S26.313 3.5 24.13 3.5s-3.952 1.754-3.952 3.917 1.769 3.917 3.951 3.917ZM24.067 44.5c8.212 0 14.87-6.599 14.87-14.739s-6.658-14.74-14.87-14.74-14.87 6.6-14.87 14.74 6.658 14.74 14.87 14.74Z"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                stroke: "#000",
                strokeMiterlimit: 10,
                strokeWidth: 1.31,
                d: "M26.395 20.06h-5.147c-1.483 0-2.684 1.192-2.684 2.662v10.495c0 1.47 1.201 2.662 2.684 2.662h5.147c1.483 0 2.685-1.192 2.685-2.662V22.722c0-1.47-1.202-2.661-2.685-2.661Z"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                stroke: "#000",
                strokeMiterlimit: 10,
                strokeWidth: 1.31,
                d: "M19 27.753s4.202-1.591 4.746-7.701m5.111 8.02s-4.201-1.91-4.745-8.02"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.31,
                d: "M13.247 39.699s-.312 0 6.395-4.218c2.195 6.27 8.26 2.945 8.26 0l6.717 4.227M23.79 27.567v3.042M21.222 32.333a4.66 4.66 0 0 0 2.4.822c1.489.08 2.56-.592 2.898-.822"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                stroke: "#000",
                strokeMiterlimit: 10,
                strokeWidth: 1.31,
                d: "M24.13 14.835V8.23M5.95 19.238l5.344 3.13M42.496 19.238l-5.317 3.13"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fill: "#000",
                d: "m24.13 6.197-1.91 2.706h3.81zM3.881 18.036l1.41 2.988L7.2 17.753zM44.324 18.036l-1.41 2.988-1.908-3.271zM24.852 19.875c-1.213.398.58 4.677.58 4.677s2.765 4.112 3.684 2.856c.918-1.255-.41-5.995-.41-5.995zM22.836 19.875c1.213.398-.58 4.677-.58 4.677s-2.765 4.112-3.684 2.856c-.918-1.255.723-6.269.723-6.269z"
            })
        ]
    });
const SSO = SvgSso;
export { SSO as default };
